import useMedia from "use-media"

export function useMediaQueries() {
  const isDesktop = useMedia({ minWidth: "56em" })
  const isTablet = useMedia({ maxWidth: "895px", minWidth: "40em" })
  const isMobile = useMedia({ maxWidth: "639px" })

  return { isDesktop, isTablet, isMobile }
}
